var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3524 0.591C10.9589 0.19692 10.4919 0 9.95304 0H1.99065C1.45177 0 0.9851 0.19692 0.59096 0.591C0.197132 0.98486 -0.000244141 1.45124 -0.000244141 1.99058V17.9153C-0.000244141 18.4544 0.197132 18.9208 0.59096 19.3148C0.9851 19.7089 1.45177 19.9058 1.99065 19.9058H9.95304C10.4919 19.9058 10.9589 19.7087 11.3524 19.3148C11.7463 18.9208 11.9436 18.4544 11.9436 17.9153V1.99058C11.9436 1.45124 11.7466 0.98508 11.3524 0.591ZM10.4512 15.427C10.4512 15.5619 10.4017 15.679 10.3031 15.7773C10.2043 15.8755 10.0877 15.9245 9.95335 15.9245H1.99065C1.8557 15.9245 1.73912 15.8753 1.64089 15.7773C1.54236 15.679 1.49308 15.5619 1.49308 15.427V4.47902C1.49308 4.34418 1.54236 4.22744 1.64089 4.12918C1.73942 4.03072 1.8557 3.98116 1.99065 3.98116H9.95304C10.0877 3.98116 10.2043 4.03072 10.3031 4.12918C10.4017 4.22744 10.4506 4.34418 10.4506 4.47902V15.427H10.4512Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSvg);
export default __webpack_public_path__ + "static/media/PhoneSvg.8f57836011e80bebf340946bf2d658ea.svg";
export { ForwardRef as ReactComponent };